"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptureProvider = void 0;
var tslib_1 = require("tslib");
var CaptureProvider = /** @class */ (function () {
    function CaptureProvider() {
    }
    CaptureProvider.isCaptureProvider = function (c) {
        return typeof c.getCaptures === 'function';
    };
    CaptureProvider.getCaptures = function (c) {
        var collections = [];
        c.forEachField(function (field) {
            var e_1, _a;
            if (!CaptureProvider.isCaptureProvider(field)) {
                return;
            }
            var fieldCaptures = field.getCaptures() || [];
            try {
                for (var fieldCaptures_1 = tslib_1.__values(fieldCaptures), fieldCaptures_1_1 = fieldCaptures_1.next(); !fieldCaptures_1_1.done; fieldCaptures_1_1 = fieldCaptures_1.next()) {
                    var fieldCapture = fieldCaptures_1_1.value;
                    collections.push(fieldCapture);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (fieldCaptures_1_1 && !fieldCaptures_1_1.done && (_a = fieldCaptures_1.return)) _a.call(fieldCaptures_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        return collections;
    };
    CaptureProvider.getCaptureIds = function (c) {
        if (!c) {
            return [];
        }
        var collections = [];
        c.forEachField(function (field) {
            var e_2, _a;
            if (!CaptureProvider.isCaptureProvider(field)) {
                return;
            }
            var fieldCaptures = field.getCaptureIds() || [];
            try {
                for (var fieldCaptures_2 = tslib_1.__values(fieldCaptures), fieldCaptures_2_1 = fieldCaptures_2.next(); !fieldCaptures_2_1.done; fieldCaptures_2_1 = fieldCaptures_2.next()) {
                    var fieldCapture = fieldCaptures_2_1.value;
                    collections.push(fieldCapture);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (fieldCaptures_2_1 && !fieldCaptures_2_1.done && (_a = fieldCaptures_2.return)) _a.call(fieldCaptures_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        });
        return collections;
    };
    return CaptureProvider;
}());
exports.CaptureProvider = CaptureProvider;
//# sourceMappingURL=capture.provider.js.map